module.exports = __webpack_public_path__ + "_resource/deco.86aae.png";